import React, { useState, useRef, useEffect } from "react";

const DotDropdown = ({ dotId, position, selectedValue, onClose, dotData }) => {
    const [selectedOption1, setSelectedOption1] = useState(dotData?.consistency || dotData?.selectedOption1 || "");
    const [selectedOption2, setSelectedOption2] = useState(dotData?.fixity || dotData?.selectedOption2 || "");
    const [textValue, setTextValue] = useState(dotData?.size || dotData?.textValue || "");

    // For Nipple Discharge
    const [dischargeType, setDischargeType] = useState(dotData?.Discharge || dotData?.dischargeType || dotData?.selectedOption1 || "");
    const [dischargeOther, setDischargeOther] = useState(dotData?.OtherDisc || dotData?.dischargeOther || dotData?.textValue || "");

    const dropdownRef = useRef();

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                onClose();
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [onClose]);

    const isNippleDischarge = selectedValue === "Nipple Discharge";

    return (
        <div ref={dropdownRef} className="dropdown customeDropDownCheckBreast" style={{ top: position.top, left: position.left }} onClick={(e) => e.stopPropagation()}>
            <div className="headers">
                <h4>{selectedValue}</h4>
            </div>
            <div className="dropDownBody">
                {isNippleDischarge ? (
                    <>
                        <div className="fields">
                            <label style={{ display: 'block', marginBottom: '4px', fontSize: '13px', fontWeight: 600, color: '#333' }}>Discharge</label>
                            <select value={dischargeType} onChange={(e) => setDischargeType(e.target.value)}>
                                <option value="">Select</option>
                                <option value="Serous/watery">Serous/watery</option>
                                <option value="Blood">Blood</option>
                                <option value="Milk">Milk</option>
                                <option value="Pus">Pus</option>
                                <option value="Other">Other</option>
                            </select>
                        </div>
                        {dischargeType === "Other" && (
                            <div className="fields">
                                <label style={{ display: 'block', marginBottom: '4px', fontSize: '13px', fontWeight: 600, color: '#333' }}>Other</label>
                                <input
                                    type="text"
                                    placeholder="Enter Discharge type is 'Other'"
                                    value={dischargeOther}
                                    onChange={(e) => setDischargeOther(e.target.value)}
                                />
                            </div>
                        )}
                    </>
                ) : (
                    <>
                        <div className="fields">
                            <select value={selectedOption1} onChange={(e) => setSelectedOption1(e.target.value)}>
                                <option value="">Select Consistency</option>
                                <option value="Hard">Hard</option>
                                <option value="Firm">Firm</option>
                                <option value="Soft">Soft</option>
                            </select>
                        </div>
                        <div className="fields">
                            <select value={selectedOption2} onChange={(e) => setSelectedOption2(e.target.value)}>
                                <option value="">Select Fixity</option>
                                <option value="To the skin">To the skin</option>
                                <option value="To the nipple areola">To the nipple areola</option>
                                <option value="Fixed to muscle">Fixed to muscle</option>
                                <option value="Fixed to chest wall">Fixed to chest wall</option>
                            </select>
                        </div>
                        <div className="fields">
                            <input
                                type="text"
                                placeholder="Size (mm)"
                                value={textValue}
                                onChange={(e) => setTextValue(e.target.value)}
                            />
                        </div>
                    </>
                )}
                <div className="fields btnFeilds">
                    <button className="cancel" onClick={onClose}>
                        CANCEL
                    </button>
                    <button
                        className="saveData"
                        onClick={() => {
                            window.dispatchEvent(new CustomEvent("dotDataSaved", {
                                detail: {
                                    dotId,
                                    data: isNippleDischarge ? {
                                        Discharge: dischargeType,
                                        OtherDisc: dischargeType === "Other" ? dischargeOther : "",
                                        dischargeType,
                                        dischargeOther,
                                        selectedOption1: dischargeType,
                                        textValue: dischargeOther
                                    } : {
                                        selectedOption1,
                                        selectedOption2,
                                        textValue
                                    },
                                    type: selectedValue
                                }
                            }));
                        }}
                    >
                        SAVE
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DotDropdown;